/**
 * Adzuki.buckets
 */

(function Buckets($, Adzuki)
{
	"use strict";

	var multiBucketData = [];

	var buckets = {
		initAddButton: function init($el) {
			// hide any popover when clicking anywhere else on the page
			$('body').off('click._dismissBucketPopovers').on('click._dismissBucketPopovers', function _dismissPopovers(e) {
				var $target = $(e.target);

				// If the click was on the trigger element itself (or inside it), do nothing
				if ($target.closest($el).length > 0) {
					return;
				}

				if (
					!$target.hasClass('bucket-addto')
					&& $target.parents('.popover.in').length === 0
					&& $target.parents('.popover.show').length === 0
				) {
					$el.popover('hide');
				}
			});

			$el.popover({
				container: 'body',
				title    : 'Your Recent Buckets',
				content  : '<p class="bucket-popover-msg"><img src="' + Adzuki.base_uri + '/adzuki/images/ajax-loader.gif"> Loading buckets...</p>',
				html     : true,
				placement: 'bottom',
				trigger  : 'manual'

			});

			$el.off().on('click', function addToClicked(e) {
				e.preventDefault();
				e.stopPropagation();

				addToBucket($(this), $el);
			});
		}
	};

	buckets.openBuckets = function openBuckets(specific_bucket_id)
	{
		var $modal = $('.modal');

		$modal.addClass('wide');
		$modal.find('.modal-body').html('<i class="' + Adzuki.FaIcon.getIconStyle('spinner') + ' fa-spin fa-2x"></i>&nbsp;Loading buckets...');

		Adzuki.Ajax.get('/Buckets/')
			.then(function _showBuckets(html) {
				$modal.find('.modal-body').html(html);
				$modal.find('[data-toggle^="tooltip"]').tooltip();
				$modal.find('[data-toggle^="collapse"]').collapse();

				if (specific_bucket_id === undefined) {
					loadFirstBucket();
				} else {
					loadBucket(specific_bucket_id);
				}
		});

		$modal.find('.modal-title').html('Buckets - <a href="' + Adzuki.erez_url + Adzuki.base_uri + '/Buckets/manage">Manage Buckets</a>');
		$modal.on('hidden.bs.modal', function _restoreModal() {
			$modal.removeClass('wide').off('hidden.bs.modal');
		}).modal('show');
	};

	$(document).ready(function documentReady()
	{
		var $modal = $('.modal');

		$('.bucket-link a').click(function _clickBucket(e) {
			e.preventDefault();
			buckets.openBuckets();
		});

		$('.bucket-check').click(function _checkBucket(e) {
			buildMultiple();
		});

		$('.show-more-emails').click(function _onShowMoreEmailsClick(e)
		{
			var $target = $(e.currentTarget);

			e.preventDefault();

			$target.parent().find('.additional_emails').toggleClass('hidden');
		});

		$('.sent-bucket').click(function _showEmail(e) {
			var $self          = $(this),
				$modal         = $(".modal"),
				iframe_src     = $self.data("iframe-src"),
				iframe_height  = $self.data("iframe-height") || 500,
				iframe_width   = $self.data("iframe-width") || '100%';

			e.preventDefault();

			$modal.addClass('wide');

			$modal.find('.modal-body').html('<iframe frameborder="0"></iframe>');

			$modal.find('iframe').attr({
				src   : iframe_src,
				height: iframe_height,
				width : iframe_width
			});

			$modal.find('.modal-title').text('');

			$modal.on('hidden.bs.modal', function _restoreModal() {
				$modal.removeClass('wide').off('hidden.bs.modal');
			}).modal('show');
		});

		$modal.on('click', '.bucket-item-link', function bucketItemClicked(e) {
			e.preventDefault();
			bucketListItem($(this).attr('id'));

			$('.modal').scrollTop(0);
		});

		$modal.on('click', '.add-new-bucket', function newBaskedClicked(e) {
			e.preventDefault();
			bucketNew();

			$(this).addClass('active');
		});

		$modal.on('click', '.bucket-view', function _viewItemClicked(e) {
			e.preventDefault();
			bucketView($(this).data("id"), $(this).data("type"));
		});

		$modal.on('click', '.bucket-delete', function _deleteItemClicked(e) {
			e.preventDefault();
			bucketDelete($(this).data("id"), $(this).data("bucket-id"));
		});

		$modal.on('click', '.bucket-item-edit', function _editItemClicked(e) {
			e.preventDefault();
			bucketEditItem($(this).data('id'), $(this).data('bucket-id'), $(this).data('type'));
		});

		$modal.on('click', '.remove-bucket', function _bucketRemoveClicked(e) {
			e.preventDefault();
			e.stopPropagation();

			bucketRemove($(this).data("id"));
		});

		$modal.on('click', '.note-detail', function _bucketItemNoteClicked(e) {
			var note_id   = $(this).data("id"),
				note      = $(this).data("note"),
				note_html = generateNoteHtml(note_id, note);

			e.preventDefault();
			e.stopPropagation();

			$('#note-' + note_id).html(note_html);
		});

		$modal.on('click', '.note-detail-add', function bucketItemNoteAddClicked(e) {
			var note_id   = $(this).data("id"),
				note_html = generateNoteHtml(note_id, '');

			e.preventDefault();
			e.stopPropagation();

			$('#note-' + note_id).html(note_html);
		});

		$modal.on('click', '.save-note', function noteSave() {
			var note_id      = $(this).data("id"),
				note         = $('#modified-' + note_id),
				note_content = note.val().trim(),
				html_content = '';

			if (note_content === '') {
				Adzuki.StatusMessage(null, 'Your note is currently empty. Please add a note before clicking Save button', 'Note empty');
			} else {
				Adzuki.Ajax.post('/Buckets/saveNote',
					{
						id  : note_id,
						note: note_content
					}
				)
				.then(function success(data) {
					html_content = '<a href="#" class="note-detail" data-id="' + note_id + '" data-note="' + note_content + '" data-toggle="tooltip" title="Edit Note"><small><i class="'+Adzuki.FaIcon.getIconStyle('edit')+' fa-lg"></i></small></a>&nbsp;';
					html_content += '<a href="#" class="note-delete" data-id="' + note_id + '" data-note="' + note_id + '" data-toggle="tooltip" title="Delete Note"><small><i class="'+Adzuki.FaIcon.getIconStyle('trash_alt')+' fa-lg"></i></small></a>&nbsp;';
					html_content += '<small>' + note_content + '</small> <i style="color: green" class="'+Adzuki.FaIcon.getIconStyle('check')+'" id="note-check-' + note_id + '"></i>';

					$('#note-' + note_id).html(html_content);

					$('#note-check-' + note_id).fadeOut(1500);
				});
			}
		});

		$modal.on('click', '.note-delete', function bucketDeleteNote(e) {
			var note_id      = $(this).data("id");

			e.preventDefault();

			Adzuki.CustomConfirm({
				title  : 'Decision Time',
				content: 'Are you sure you wish to delete this note?',
				confirm: function confirm() {
					Adzuki.Ajax.get('/Buckets/deleteNote/' + note_id).then(function success(data) {
						$('#note-' + note_id).html('<a href="#" class="note-detail-add" data-id="' + note_id + '"><small><i class="'+Adzuki.FaIcon.getIconStyle('plus')+' fa-lg"></i> Add Note</small></a>');
					});
				}
			});
		});

		$modal.on('click', '.cancel-note', function bucketCancelNote(e) {
			var note_id      = $(this).data("id"),
				note_content = $(this).data("content"),
				html_content = '';

			e.preventDefault();

			if (note_content.length === 0) {
				$('#note-' + note_id).html('<a href="#" class="note-detail-add" data-id="' + note_id + '"><small><i class="'+Adzuki.FaIcon.getIconStyle('plus')+' fa-lg"></i> Add Note</small></a>');
			} else {
				html_content = '<a href="#" class="note-detail" data-id="' + note_id + '" data-note="' + note_content + '" data-toggle="tooltip" title="Edit Note"><small><i class="'+Adzuki.FaIcon.getIconStyle('edit')+' fa-lg"></i></small></a>&nbsp;';
				html_content += '<a href="#" class="note-delete" data-id="' + note_id + '" data-note="' + note_id + '" data-toggle="tooltip" title="Delete Note"><small><i class="'+Adzuki.FaIcon.getIconStyle('trash_alt')+' fa-lg"></i></small></a>&nbsp;';
				html_content += '<span class="note-text">' + note_content + '</span>';

				$('#note-' + note_id).html(html_content);
			}
		});

		$modal.on('click', '.bucket-actions-dropdown', function _actionsDropdown(e) {
			e.preventDefault();

			$('.bucket-actions-dropdown').dropdown();
		});

		$modal.on('click', '.edit-bucket', function _editBucket(e) {
			e.preventDefault();
			e.stopPropagation();

			if ($(this).hasClass('disabled')) {
				Adzuki.StatusMessage(null, 'You do not have access to edit this bucket', 'Cannot Edit!');
			} else {
				document.location = Adzuki.erez_url + Adzuki.base_uri + '/Buckets/edit/' + $(this).data('id');
			}
		});

		$modal.on('click', '.email-bucket', function bucketEmailClicked(e) {
			e.preventDefault();
			e.stopPropagation();

			if ($(this).hasClass('disabled')) {
				Adzuki.StatusMessage(null, 'Your bucket is currently empty. Please add items in order to be able to email it', 'Cannot email!');
			} else {
				document.location = Adzuki.erez_url + Adzuki.base_uri + '/Buckets/email/' + $(this).data("id");
			}
		});

		$modal.on('click', '.text-bucket', function bucketTextClicked(e) {
			e.preventDefault();
			e.stopPropagation();

			if ($(this).hasClass('disabled')) {
				Adzuki.StatusMessage(null, 'Your bucket is currently empty. Please add items in order to be able to send it via a text message', 'Cannot send text!');
			} else {
				document.location = Adzuki.erez_url + Adzuki.base_uri + '/Buckets/text/' + $(this).data('id');
			}
		});

		$modal.on('click', '.duplicate-bucket', function _duplicateBucketClick(e) {
			e.preventDefault();
			e.stopPropagation();

			if ($(this).hasClass('disabled')) {
				Adzuki.StatusMessage(null, 'Your bucket is currently empty. Please add items in order to be able to duplicate it', 'Cannot duplicate!');
			} else {
				document.location = Adzuki.erez_url + Adzuki.base_uri + '/Buckets/duplicate/' + $(this).data("id");
			}
		});

		$modal.on('click', '.copy-bucket', function _copyBucketClicked(e) {
			e.preventDefault();
			e.stopPropagation();

			if ($(this).hasClass('disabled')) {
				Adzuki.StatusMessage(null, 'Your bucket is currently empty. Please add items in order to be able to copy items from it to another bucket', 'Cannot Copy!');
			} else {
				document.location = Adzuki.erez_url + Adzuki.base_uri + '/Buckets/copy/' + $(this).data('id');
			}
		});

		$modal.on('change', '.bucket-select', function bucketSelect() {
			if ($(this).val() === '+ create') {
				$('.bucket-add-form').fadeIn().addClass('hidden');
				$('.bucket-new-form').fadeOut().removeClass('hidden');

				Adzuki.ClientOpportunityTypeAhead.readyForAction();
			}
		});

		$modal.on('click', '.new-bucket-cancel', function cancelNewBucket(e) {
			e.preventDefault();

			$('.bucket-new-form').fadeIn().addClass('hidden');
			$('.bucket-add-form').fadeOut().removeClass('hidden');

			$('#bucket-name').val('');
			$('.bucket-select').val('');
			$('.bucket-new-form .recipients .remove-all').click();
		});

		$modal.on('click', '.cancel-add-to', function addToCanceled(e) {
			e.preventDefault();
			$modal.modal('hide');
		});

		// clicked from the add to bucket link within a travel component
		if ($('.bucket-addto').length > 0) {
			buckets.initAddButton($('.bucket-addto'));
		}

		$modal.on('click', 'form .delete-checked', function bulkDelete(event) {
			var $form       = $(this).closest('form'),
			    items_txt   = 'items',
			    num_checked = 0;

			$('.bucket-checkboxes').each(function checkIfChecked() {
				if ($(this).prop('checked') === true) {
					num_checked++;
				}
			});

			if (num_checked > 0) {
				if ($form.data('entity-type')) {
					items_txt = $form.data('entity-type');
				}

				Adzuki.CustomConfirm({
					body   : 'Are you sure you wish to delete these ' + items_txt + '?',
					confirm: function successFunction() {
						$form.submit();
						// window.location.reload();
					}
				});
			} else {
				Adzuki.StatusMessage(null, 'Please select at least one bucket', 'Nothing selected');

				return false;
			}
		});

		$modal.on('click', '.folder-name', function toggleFolderByName() {
			$(this).parent().prev().trigger("click");
		});

		$modal.on('click', '.bucket-content-item-close', function _closeContentItem(e) {
			e.preventDefault();

			$('#bucket-item-content-preview').addClass('hidden');
			$('#bucket-item-content-preview').html('');
		});
	});

	function addToBucket($self, $bucket_element)
	{
		var bucket_data = {
			item_id         : $self.data('item-id'),
			item_type       : $self.data('item-type'),
			item_description: $self.data('item-description'),
			item_image      : $self.data('item-image'),
			supplier_name   : $self.data('supplier-name'),
			multiple        : '0',
		};

		if ($self.data('multiple')) {
			bucket_data.multiple = '1';
			bucket_data.items    = $self.next().val();
		}

		if ($self.data('itinerary-type')) {
			bucket_data.itinerary_type = $self.data('itinerary-type');
		}

		if ($self.data('flight-source')) {
			bucket_data.flight_source = $self.data('flight-source');
		}

		if ($self.data('hotel-code')) {
			bucket_data.hotel_code = $self.data('hotel-code');
		}

		// open the popover
		$self.popover('show');

		Adzuki.Ajax.get('/Buckets/getRecentlyUpdated')
			.then(function _recentlyUpdated(response) {
				var $tip = null;
				var $contentHost = null;

				// Bootstrap stores the popover instance differently depending on version
				var popoverInstance = $self.data('bs.popover') || $self.data('popover');
				if (popoverInstance && typeof popoverInstance.tip === 'function') {
					$tip = $(popoverInstance.tip());
				}

				// Fallback: last visible popover
				if (!$tip || $tip.length === 0) {
					$tip = $('.popover.show, .popover.in').last();
				}

				// Support BS3 (.popover-content) and BS4/5 (.popover-body)
				$contentHost = $tip.find('.popover-body');
				if ($contentHost.length === 0) {
					$contentHost = $tip.find('.popover-content');
				}

				$contentHost.html(response);

				_addHandlersToAddItems($bucket_element, bucket_data);
				_initQuickSearch($bucket_element, bucket_data);
				_initQuickAdd($bucket_element, bucket_data);
			});
	}

	function _addHandlersToAddItems($bucket_element, bucket_data)
	{
		// add the item into the bucket
		$('.add-item-to-bucket').off().on('click', function _addToBucket(e) {
			var bucket_id = $(this).data('bucket-id');

			e.preventDefault();
			e.stopPropagation();

			if ($(this).hasClass('disabled')) {
				return;
			}

			Adzuki.Ajax.post('/Buckets/addQuickItem/' + bucket_id, bucket_data)
			.then(function _addItem(response) {
				var toast_content = null;

				$bucket_element.popover('hide');

				if (response.error) {
					Adzuki.StatusMessage('error', response.error);
					return;
				}

				if (bucket_data.multiple === '1') {
					toast_content = '<strong>Multiple items</strong> have been added to ';
				} else {
					toast_content = '<strong>' + bucket_data.item_description + '</strong>';
					toast_content += ' has been added to ';
				}

				toast_content += '<strong>' + response.bucket_name + '</strong>';

				_toastMessage(toast_content, bucket_id, response.bucket_item_id);
				// Announced for any page that wants to know an add succeeded — Maxx
				// Assist records it as an export of the summary. Inert elsewhere.
				$(document).trigger('bucket:item-added', [bucket_id, response, bucket_data]);
			});
		});

		// handler to open modal to select a different bucket
		$('.select-another-bucket-btn').off().on('click', function _selectAnother(e) {
			var $modal      = $('.modal');
			var modal_title = 'Buckets';

			e.preventDefault();
			e.stopPropagation();

			$bucket_element.popover('hide');

			$modal.addClass('wide');
			$modal.find('.modal-body').html('<i class="' + Adzuki.FaIcon.getIconStyle('spinner') + ' fa-spin fa-2x"></i>&nbsp;Loading bucket...');

			Adzuki.Ajax.post('/Buckets/addItem/1', bucket_data)
			.then(function _showAddItem(response) {
				$modal.find('.modal-body').html(response);
				$modal.find('[data-toggle^="tooltip"]').tooltip();

				Adzuki.Form.initAjaxForm('BucketItem');
			});

			if (bucket_data.item_description) {
				modal_title = bucket_data.item_description;
			}

			if (bucket_data.supplier_name) {
				modal_title += ' - ' + bucket_data.supplier_name;
			}

			$modal.find('.modal-title').text(modal_title);
			$modal.on('hidden.bs.modal', function _restoreModal() {
				$modal.removeClass('wide').off('hidden.bs.modal');
			}).modal('show');
		});
	}

	// eslint-disable-next-line no-unused-vars
	function addToBucketWithModal($self)
	{
		var $modal     = $('.modal');
		var flight_url = null;
		var hotel_url  = null;
		var postdata   = {
			item_id         : $self.data('item-id'),
			item_type       : $self.data('item-type'),
			item_description: $self.data('item-description'),
			item_image      : $self.data('item-image'),
			supplier_name   : $self.data('supplier-name'),
		};

		if ($self.data('multiple')) {
			postdata.multiple = true;
			postdata.items    = $self.next().val();
		}

		// if air, generate pdf of itinerary and then render the form
		if ($self.data('item-type') === 'air') {
			if (Cookies.get('cached_air_pnr_bucket_item')) {
				generateDesktopForm(JSON.parse(Cookies.get('cached_air_pnr_bucket_item')));
			} else {
				flight_url = '/FlightBooking/generateItineraryPdf/';

				if ($self.data('itinerary-type')) {
					flight_url += $self.data('itinerary-type') + '/';
				}

				if ($self.data('flight-source')) {
					flight_url += $self.data('flight-source');
				}

				Adzuki.Ajax.get(flight_url).then(function success(response) {
					if (response.completed) {
						postdata.item_id = response.flight_pdf_itinerary_id;
						Cookies.set('cached_air_pnr_bucket_item', postdata);
						generateDesktopForm(postdata);
					}
				});
			}

			return;
		}

		// If hotel, generate pdf and then render the form
		if ($self.data('item-type') === 'hotel') {
			hotel_url = '/HotelBooking/generateHotelSummaryPdf/' + $self.data('hotel-code');

			$modal.addClass('wide');
			$modal.find('.modal-body').html('<i class="'+Adzuki.FaIcon.getIconStyle('spinner')+' fa-spin fa-2x"></i>&nbsp;Loading...');
			$modal.modal('show');

			Adzuki.Ajax.get(hotel_url).then(function success(response) {
				if (response.completed) {
					postdata.item_id = response.hotel_summary_id;
					generateDesktopForm(postdata);
				}
			});

			return;
		}

		generateDesktopForm(postdata);
	}

	function bucketListItem(id) {
		var target_id = id.replace("bucket-item-", "");

		$('div.bucket .list-group-item').each(function toggleBucketItemState() {
			$(this).removeClass('active');
		});

		$('#' + id).addClass('active');

		_loadBucketItems(target_id);
	}

	function bucketView(id, type) {
		if (type === 'link' || type === 'trip_summary' || type === 'video') {
			window.open(Adzuki.base_uri + '/Buckets/viewItem/' + id);
		} else if (type === 'content') {
			$('#bucket-item-content-preview').removeClass('hidden');
			$('#bucket-item-content-preview').html('<i class="'+Adzuki.FaIcon.getIconStyle('spinner')+' fa-spin fa-2x"></i>&nbsp;Loading bucket item.');
			Adzuki.Ajax.get('/Buckets/contentItem/' + id)
			.then(function _contentBucket(content) {
				$('#bucket-item-content-preview').html(content);
			});
		} else if (type === 'flight' || type === 'insurance' || type === 'transfer') {
			// Maxx Assist items with no page to open: their detail is stored on
			// the row and shown inline, like a content item, so the list stays
			// put. This branch also catches the thumbnail click, which used to
			// land these types on the dead viewItem page.
			$('#bucket-item-content-preview').removeClass('hidden');
			$('#bucket-item-content-preview').html('<i class="'+Adzuki.FaIcon.getIconStyle('spinner')+' fa-spin fa-2x"></i>&nbsp;Loading bucket item.');
			Adzuki.Ajax.get('/Buckets/itemDetail/' + id)
			.then(function _detailBucket(content) {
				$('#bucket-item-content-preview').html(content);
			});
		} else {
			document.location = Adzuki.base_uri + '/Buckets/viewItem/' + id;
		}
	}

	function bucketDelete(id, bucket_id) {
		var current_amount = $('#bucket-item-count-' + bucket_id).html();
		var new_amount     = parseInt(current_amount) - 1;

		if (new_amount <= 0) {
			new_amount = 0;
		}

		Adzuki.CustomConfirm({
			title  : 'Decision Time',
			content: 'Are you sure you want to remove this item from the bucket?',
				confirm: function confirm() {
					Adzuki.Ajax.get('/Buckets/deleteItem/' + id);

					$('#bucket-item-id-' + id).addClass('hidden');
					$('#bucket-item-count-' + bucket_id).html(new_amount);

					Adzuki.StatusMessage('Success', 'The item has been deleted');
				}
		});
	}

	function bucketEditItem(id, bucket_id, item_type)
	{
		var event_data = {
			bucket_id  : bucket_id,
			bucket_type: item_type,
		};

		$('.modal').scrollTop(0);

		if (item_type === 'link') {
			$('.bucket-show-links').trigger('click');

			Adzuki.Ajax.get('/Buckets/addEditLink/' + bucket_id + '/' + id)
			.then(function _editLink(response) {

				$('#bucket-links').html(response);
				$('.cancel-bucket-item-edit').on('click', event_data, _cancelItemBucketEdit);

				Adzuki.Form.initAjaxForm('BucketLink');
			});
		} else if (item_type === 'attachment') {
			$('.bucket-show-attachments').trigger('click');

			Adzuki.Ajax.get('/Buckets/addEditAttachment/' + bucket_id + '/' + id)
			.then(function _editAttachment(response) {
				$('#bucket-files').html(response);
				$('.cancel-bucket-item-edit').on('click', event_data, _cancelItemBucketEdit);

				Adzuki.Form.initAjaxForm('BucketAttachment');
				buckets.initializeDragAndDrop();
			});
		} else {
			Adzuki.Ajax.get('/Buckets/editItem/' + bucket_id + '/' + id)
			.then(function _editItem(response) {
				$('#bucket-items').html(response);
				$('.cancel-bucket-item-edit').on('click', event_data, _cancelItemBucketEdit);

				Adzuki.Form.initAjaxForm('BucketItemEdit');
			});
		}
	}

	function bucketNew() {
		document.location = Adzuki.erez_url + Adzuki.base_uri + '/Buckets/add/';
	}

	function bucketRemove(id) {
		var current_amount = $('.bucket-link a').attr('data-amount'),
			new_amount     = parseInt(current_amount) - 1,
			$modal         = $('.modal');

		if (new_amount <= 0) {
			new_amount = 0;
		}

		Adzuki.CustomConfirm({
			title  : 'Decision Time',
			content: 'Are you sure you want to delete this entire bucket?',
			confirm: function confirm() {
				Adzuki.Ajax.get('/Buckets/delete/' + id);

				Adzuki.StatusMessage('Success', 'Your bucket has been deleted');

				$('.bucket-link a').attr('data-amount', new_amount);
				$modal.modal('hide');
			}
		});
	}

	function _cancelItemBucketEdit(e)
	{
		var bucket_type = e.data.bucket_type;
		var bucket_id   = e.data.bucket_id;

		e.preventDefault();

		if (bucket_type === 'link') {
			$('.bucket-show-items').trigger('click');

			Adzuki.Ajax.get('/Buckets/addEditLink/' + bucket_id)
			.then(function _addEditLink(response) {
				$('#bucket-links').html(response);
				Adzuki.Form.initAjaxForm('BucketLink');
			});
		} else if (bucket_type === 'attachment') {
			$('.bucket-show-items').trigger('click');

			Adzuki.Ajax.get('/Buckets/addEditAttachment/' + bucket_id)
			.then(function _addEditAttachment(response) {
				$('#bucket-files').html(response);
				Adzuki.Form.initAjaxForm('BucketAttachment');
				buckets.initializeDragAndDrop();
			});
		} else {
			_loadBucketItems(bucket_id);
		}
	}

	function _editBucketLink(bucket_id, bucket_item_id)
	{
		var $btn = $('.edit-bucket-details');

		if ($btn.length <= 0) {
			return;
		}

		$btn.off().on('click', function _openEditModal(e) {
			var $modal = $('.modal');

			e.preventDefault();

			$modal.addClass('wide');
			$modal.find('.modal-body').html('<i class="' + Adzuki.FaIcon.getIconStyle('spinner') + ' fa-spin fa-2x"></i>&nbsp;Loading bucket item...');
			$modal.find('.modal-title').text('Bucket Item');
			$modal.on('hidden.bs.modal', function _restoreModal() {
				$modal.removeClass('wide').off('hidden.bs.modal');
			}).modal('show');

			Adzuki.Ajax.get('/Buckets/editItem/' + bucket_id + '/' + bucket_item_id + '/1')
			.then(function _editItem(response) {
				$modal.find('.modal-body').html(response);

				$('.cancel-bucket-item-edit').on('click', function _onCancel(e) {
					e.preventDefault();
					$modal.modal('hide');
				});

				Adzuki.Form.initAjaxForm('BucketItemEdit');
			});
		});
	}

	function generateDesktopForm(postdata)
	{
		var $modal = $('.modal');

		$modal.addClass('wide');
		$modal.find('.modal-body').html('<i class="'+Adzuki.FaIcon.getIconStyle('spinner')+' fa-spin fa-2x"></i>&nbsp;Loading buckets...');

		Adzuki.Ajax.post('/Buckets/addItem/', postdata)
			.then(function _showAddItems(html) {
				$modal.find('.modal-body').html(html);
				$modal.find('[data-toggle^="tooltip"]').tooltip();

				Adzuki.Form.initAjaxForm('BucketItem');
				Adzuki.Form.initAjaxForm('Bucket');
				Adzuki.DragDropUpload.init($('.drag-drop-container'));
		});

		$modal.find('.modal-title').text('Buckets');
		$modal.on('hidden.bs.modal', function _restoreModal() {
			$modal.removeClass('wide').off('hidden.bs.modal');
		}).modal('show');
	}

	function _initQuickAdd($bucket_element, bucket_data)
	{
		var $input = $('.bucket-quick-add-field').first();

		// enable button to create the new bucket if there is text entered
		$input.on('keyup', function _onKeyup() {
			if ($input.val().length > 1) {
				$('.quick-bucket-add-btn').removeClass('disabled');
				return;
			}

			$('.quick-bucket-add-btn').addClass('disabled');
		});

		// create a new bucket quickly
		$('.quick-bucket-add-btn').off().on('click', function _quickAddBucket(e) {
			var bucket_name = $input.val();

			e.preventDefault();
			e.stopPropagation();

			// display error if no value entered
			if (bucket_name === '') {
				Adzuki.StatusMessage('error', 'You must enter a name for your Bucket', 'Error!');
				return;
			}

			// first create the bucket
			Adzuki.Ajax.post('/Buckets/create/', { name: bucket_name })
			.then(function _createBucket(response) {
				var bucket_id = null;

				if (response.error) {
					Adzuki.StatusMessage('error', response.error);
					return;
				}

				bucket_id = response.bucket_id;

				// done, add the item into this new bucket
				Adzuki.Ajax.post('/Buckets/addQuickItem/' + bucket_id, bucket_data)
				.then(function _addItem(response) {
					var toast_content = null;

					$input.val('');
					$bucket_element.popover('hide');

					if (response.error) {
						Adzuki.StatusMessage('error', response.error);
						return;
					}

					if (bucket_data.multiple === '1') {
						toast_content = '<strong>Multiple items</strong> have been added to ';
					} else {
						toast_content = '<strong>' + bucket_data.item_description + '</strong>';
						toast_content += ' has been added to ';
					}

					toast_content += '<strong>' + response.bucket_name + '</strong>';

					_toastMessage(toast_content, bucket_id, response.bucket_item_id);
					// Announced for any page that wants to know an add succeeded — Maxx
					// Assist records it as an export of the summary. Inert elsewhere.
					$(document).trigger('bucket:item-added', [bucket_id, response, bucket_data]);
				});
			});
		});

		// display field to enter the name of the new bucket
		$('.quick-add-bucket').off().on('click', function _quickAddBucket(e) {
			e.preventDefault();
			e.stopPropagation();

			$(this).parent().addClass('hidden');
			$('.bucket-quick-add-name').removeClass('hidden d-none');
		});

		// cancel adding a new quick bucket
		$('.close-bucket-add-name').off().on('click', function _closeAddBucket(e) {
			e.preventDefault();
			e.stopPropagation();

			$input.val('');

			$('.bucket-quick-add-name')
			.addClass('hidden d-none')
			.prev().removeClass('hidden d-none');
		});
	}

	function _initQuickSearch($bucket_element, bucket_data)
	{
		var $input = $('.bucket-quick-search').first();
		let popoverClass = '.popover-content';

		if (Adzuki.app === 'TripSummary') {
			popoverClass = '.popover-body';
		}

		// disable recent items, move search field to top, display search close icon on focus
		$input.on('focus', function _disableRecentItems() {
			$(popoverClass + ' .recent-buckets').insertAfter('.bucket-quick-item-container.search');

			$('.bucket-quick-item-container.search').addClass('margin10-bottom');
			$(popoverClass + ' .recent-buckets .list-group-item').addClass('disabled');
			$('.close-bucket-search').removeClass('hidden d-none');
		});

		// reset the text in the typeahead and move it back to the bottom
		$('.close-bucket-search').off().on('click', function _closeBucketSearch(e) {
			e.preventDefault();
			e.stopPropagation();

			$input.val('');

			$('.close-bucket-search').addClass('hidden');

			if ($(popoverClass + ' .quick-buckets-results').length > 0) {
				$(popoverClass + ' .quick-buckets-results').remove();
			}

			$(popoverClass + ' .recent-buckets .list-group-item').removeClass('disabled');
			$(popoverClass + ' .recent-buckets')
			.insertBefore('.bucket-quick-item-container.search')
			.removeClass('hidden d-none');

			$('.bucket-quick-item-container.search').removeClass('margin10-bottom');
		});

		// init typeahead
		Adzuki.Typeahead(
			$('.bucket-quick-search'),
			function _source(term, display, $self) {
				var search_term = encodeURIComponent(term);

				Adzuki.Ajax.get('/Buckets/quickSearch/' + search_term)
				.then(function _search(response) {
					$self.removeClass('ajax-spinner');

					$(popoverClass + ' .recent-buckets').addClass('hidden d-none');

					if ($(popoverClass + ' .quick-buckets-results').length > 0) {
						$(popoverClass + ' .quick-buckets-results').remove();
					}

					$(response).insertAfter(popoverClass + ' .bucket-quick-item-container.search');

					_addHandlersToAddItems($bucket_element, bucket_data);
				});
			}
		);
	}

	function loadFirstBucket()
	{
		var target_id;

		$('.bucket-item-link').each(function loopOverBuckets() {
			target_id = $(this).attr('id').replace("bucket-item-", "");

			_loadBucketItems(target_id);

			return false;
		});
	}

	function _loadBucketItems(bucket_id)
	{
		Adzuki.Ajax.get('/Buckets/items/' + bucket_id)
		.then(function _showBucketItems(content) {
			$('.bucket-contents').html(content);

			Adzuki.Ajax.get('/Buckets/addEditAttachment/' + bucket_id)
			.then(function _addEditAttachment(response) {
				$('#bucket-files').html(response);
				Adzuki.Form.initAjaxForm('BucketAttachment');
				buckets.initializeDragAndDrop();
			});

			Adzuki.Ajax.get('/Buckets/addEditLink/' + bucket_id)
			.then(function _addEditLink(response) {
				$('#bucket-links').html(response);
				Adzuki.Form.initAjaxForm('BucketLink');
			});
		});
	}

	// load a specific bucket. this will figure out if any parent folders and expand the first one upon display
	function loadBucket(bucket_id)
	{
		// determine if the bucket belongs to any folders that need to be expanded
		Adzuki.Ajax.get('/Buckets/getDetails/' + bucket_id).then(function success(response) {
			var folders = response.folders,
			    sorted_folders,
			    first_key,
			    folder_id;

			if (folders) {
				// collapse the "Uncategorized" bucket folder
				$('a[href="#folder-0"]').trigger("click");

				// alpha order of the folders associated with this bucket
				sorted_folders = Adzuki.Sort.alphabeticValue(folders);
				first_key      = Object.keys(sorted_folders)[0];
				folder_id      = sorted_folders[first_key].key;

				$(".folder").find("[data-folder-id='" + folder_id + "']").trigger("click");
			}

			$('#bucket-item-' + bucket_id).trigger("click");
		});
	}

	function buildMultiple()
	{
		var jsonData = '';
		multiBucketData.length = 0;

		$('.bucket-check').each(function buildData() {
			var data = {};

			data['id']       = $(this).data('id');
			data['title']    = $(this).data('title');
			data['image']    = $(this).data('image');
			data['supplier'] = $(this).data('supplier');
			data['type']     = $(this).data('type');

			if ($(this).prop('checked') === true) {
				multiBucketData.push(data);
			}
		});

		if (multiBucketData.length > 0) {
			jsonData = JSON.stringify(multiBucketData);

			$('#add-all-bucket').val(jsonData);
			$('.bucket-addall-button').removeClass('disabled');
		} else {
			$('#add-all-bucket').val('');
			$('.bucket-addall-button').addClass('disabled');
		}
	}

	function generateNoteHtml(note_id, note) {
		var html = '';

		html += '<div class="input-group pad10-vert">';
		html += '    <input type="text" class="form-control note-text" value="' + note + '" id="modified-' + note_id + '">';
		html += '    <span class="input-group-btn">';
		html += '        <button class="btn btn-primary save-note" data-toggle="tooltip" title="Save note" data-id="' + note_id + '" type="button">Save</button>';
		html += '        <button class="btn btn-primary cancel-note" data-toggle="tooltip" title="Cancel note" data-id="' + note_id + '" data-content="' + note + '">X</button>';
		html += '     </span>';
		html += '</div>';

		return html;
	}

	function _toastMessage(message, bucket_id, bucket_item_id)
	{
		var opts = {
			positionClass  : 'toast-top-center',
			timeOut        : 5000,
			extendedTimeOut: 5000,
			onShown        : function showToastr() {
				_editBucketLink(bucket_id, bucket_item_id);
			}
		};

		var edit_link = null;

		if (bucket_id && bucket_item_id) {
			edit_link = '<a class="edit-bucket-details text-white" href="#">Edit Details</a>';
		}

		if (Adzuki.app === 'TripSummary') {
			// use bootstrap's 5 toast
			const toastContainer = document.querySelector('.toast-container');
			const toastElement   = document.getElementById('liveToast');
			const toast          = bootstrap.Toast.getOrCreateInstance(toastElement);

			$(toastElement).off().on('shown.bs.toast', function _onShown() {
				_editBucketLink(bucket_id, bucket_item_id);
			});

			// display toast on the top-center of the screen
			toastContainer.classList.remove('bottom-0');
			toastContainer.classList.remove('end-0');
			toastContainer.classList.add('top-0');
			toastContainer.classList.add('start-50');
			toastContainer.classList.add('translate-middle-x');

			document.querySelector('.toast-body').innerHTML = message + ' ' + edit_link;
			toast.show();
		} else {
			toastr.success(
				edit_link,
				message,
				opts
			);
		}

	}

	buckets.initializeDragAndDrop = function _initializeDragAndDrop()
	{
		var $modal = $('.modal');

		setTimeout(
			function initTheDragandDrop() {
				var remove_target = '.file-upload-options .attachment-remove';
				var view_target   = '.file-upload-options .attachment-view';

				Adzuki.DragDropUpload.start($(".file-upload-options"));

				$modal.off('click', remove_target).on('click', remove_target, function removeAttachment(e) {
					var $self = $(this);

					e.stopPropagation();
					e.preventDefault();

					Adzuki.DragDropUpload.removeAttachment($self);
				});

				$modal.off('click', view_target).on('click', view_target, function viewAttachment(e) {
					var $self    = $(this),
						in_modal = false;

					e.stopPropagation();
					e.preventDefault();

					if ($self.parents('div.modal-body').length) {
						in_modal = true;
					}

					Adzuki.DragDropUpload.viewAttachment($self, in_modal);
				});
			},
		500);
	};

	Adzuki.Buckets = buckets;

}(jQuery, window.Adzuki || {}));
